import { NgClass } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { SelectButton, SelectButtonChangeEvent } from 'primeng/selectbutton';
import { I18nService } from '../../../../core/services/i18n.service';
import { CustomerGroup } from '../../../enums/organisation/customer-group';
import { PaymentMethodName } from '../../../enums/payment/payment-method-name';
import { PaymentData } from '../../../interfaces/payment/payment-data';
import { PaymentInvalidFlags } from '../../../interfaces/payment/payment-invalid-flags';

@Component({
  selector: 'edit-form-payment-type',
  imports: [
    SelectButton,
    FormsModule,
    InputText,
    NgClass,
    Message,
    Checkbox
  ],
  templateUrl: './edit-form-payment-type.component.html'
})
export class EditFormPaymentTypeComponent implements OnInit {

  @Input() paymentData: PaymentData;
  @Input() paymentInvalidFlags: PaymentInvalidFlags;
  @Input() customerGroup: CustomerGroup;

  public i18n = inject(I18nService);

  /** Options and Models */
  stateOptions = [
    {value: 'TEST', label: 'Test'},
    {value: 'LIVE', label: 'Live'},
  ];
  paymentMethod: string;

  /**
   * show warning on switch to live-mode if payment type is not activated
   */
  showSwitchLiveWarning: boolean = false;
  refreshView: boolean = false;

  ngOnInit() {
    this.paymentMethod = this.i18n.i18nLng()[this.paymentData.paymentMethod]
  }

  /**
   * checxk for valid bank-account data if switched to Live-Mode
   * @param event
   */
  paymentStatusChanged(event: SelectButtonChangeEvent) {
    // let missingBankAccountData: boolean = false;
    if (event.value === 'LIVE') {
      /**
       * Bank account check is now in Onboarding
       * here we will check if the payment type was activated by admin
       */
      /*
      if (!this.paymentData?.accountHolder || this.paymentData?.accountHolder.trim() == '') {
        missingBankAccountData = true;
      }
      if ((!this.paymentData?.IBAN || this.paymentData?.IBAN.trim() == '') || !IBAN.isValid(this.paymentData.IBAN)) {
        missingBankAccountData = true;
      }
      if (!this.paymentData?.BIC || this.paymentData?.BIC.trim() == '') {
        missingBankAccountData = true;
      }
      if (!this.paymentData?.bank || this.paymentData?.bank.trim() == '') {
        missingBankAccountData = true;
      }
       */
      this.showSwitchLiveWarning = !this.paymentData.active;
      this.refreshView = true;
      if (this.showSwitchLiveWarning) {
        setTimeout(() => {
          this.paymentData.status = 'TEST';          // content
          this.refreshView = false;
        }, 10);
      }
    }
  }

  protected readonly PaymentMethodName = PaymentMethodName;
  protected readonly CustomerGroup = CustomerGroup;
}
